import Image from "next/image"
import { getUmbracoMediaUrl } from "utils"

import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import { colors, sizes } from "ui"

const StyledImageContainer = styled(Box)`
  position: relative;
  width: 57px;
  height: 48px;
  padding: 10px;
  border-radius: ${sizes.baseSingle};
  display: flex;
  justify-content: center;
  align-items: center;
`
const StyledBoxWrapper = styled(Box)`
  border-radius: ${sizes.borderRadius};
  background: rgba(255, 255, 255, 0.8);
  box-shadow: -4.297px 8.593px 32.225px 0px rgba(2, 1, 64, 0.12);
  backdrop-filter: blur(20.76602554321289px);
  height: 226px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${sizes.baseTriple};
  cursor: pointer;
  gap: ${sizes.baseSingle};
  width: 100%;
`
const StyledTitle = styled(Typography)<{ component?: string }>`
  margin-bottom: 4px;
`
const StyledText = styled(Typography)`
  text-align: center;
`

interface ObjectWithValue {
  value: string
}
const CardBoxIconContent = ({
  title,
  text,
  icon,
  onClick,
}: {
  title: ObjectWithValue
  text: ObjectWithValue
  icon: any
  onClick: (buttonTitle: string) => void
}) => {
  return (
    <StyledBoxWrapper onClick={() => onClick(title?.value)}>
      {icon?.mediaItems && (
        <StyledImageContainer>
          <Image
            src={getUmbracoMediaUrl(icon?.mediaItems[0]?.url)}
            alt={title?.value}
            fill
            style={{ objectFit: "cover" }}
          />
        </StyledImageContainer>
      )}
      <StyledTitle variant="h5" component="h3">
        {title?.value}
      </StyledTitle>
      <StyledText variant="body1" color={colors.black}>
        {text?.value}
      </StyledText>
    </StyledBoxWrapper>
  )
}

export default CardBoxIconContent
